import React from 'react';
import { AlertTriangle, Clock, Wrench, DollarSign } from 'lucide-react';

const AlertsList = () => {
  const alerts = [
    {
      id: 1,
      type: 'maintenance',
      message: '5 assets require maintenance this week',
      timestamp: '2 hours ago',
      priority: 'high',
      icon: Wrench
    },
    {
      id: 2,
      type: 'warranty',
      message: '3 asset warranties expiring soon',
      timestamp: '5 hours ago',
      priority: 'medium',
      icon: Clock
    },
    {
      id: 3,
      type: 'value',
      message: 'Asset depreciation report ready for review',
      timestamp: '1 day ago',
      priority: 'low',
      icon: DollarSign
    }
  ];

  const getPriorityColor = (priority) => {
    switch (priority) {
      case 'high':
        return 'text-red-600 bg-red-50';
      case 'medium':
        return 'text-orange-600 bg-orange-50';
      case 'low':
        return 'text-blue-600 bg-blue-50';
      default:
        return 'text-gray-600 bg-gray-50';
    }
  };

  return (
    <div className="divide-y divide-gray-100">
      {alerts.map((alert) => {
        const Icon = alert.icon;
        return (
          <div key={alert.id} className="p-4 hover:bg-gray-50">
            <div className="flex items-center gap-4">
              <div className={`p-2 rounded-lg ${getPriorityColor(alert.priority)}`}>
                <Icon className="w-4 h-4" />
              </div>
              <div className="flex-1">
                <p className="text-sm font-medium text-gray-900">{alert.message}</p>
                <p className="text-xs text-gray-500">{alert.timestamp}</p>
              </div>
              <button className="text-sm text-blue-600 hover:text-blue-700 font-medium">
                Take Action
              </button>
            </div>
          </div>
        );
      })}
    </div>
  );
};

export default AlertsList; 